import type { PropsWithChildren } from 'react';

import st from './FastFilterGroup.module.sass';

function FastFilterGroup({
  children,
}: PropsWithChildren): React.JSX.Element {
  return (
    <div className={st.FastFilterGroup}>
      {children}
    </div>
  );
}

export { FastFilterGroup };
